export const CHART_CODES = {
    VIEWS: 'SESSION_COUNT',
    READS: 'READ_COMPLETE',
    USERS: 'UNIQUE_USERS',
    AVERAGE_ATTENTION_TIME: 'AVG_SESSION_TIME',
}
